// extracted by mini-css-extract-plugin
export default {"toggle-switch":"gHMzYDp","toggle-switch__label":"ujYrOJD","toggle-switch__switch-wrapper":"GduPWLG","toggle-switch__switch-visual":"EHBXFpB","toggle-switch__input":"XSzmT5u"};